import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant' // 导入 Vant
import 'vant/lib/index.css' // 导入 Vant 样式
import HelloWorld from '@/components/HelloWorld'
import AdminUser from '@/components/AdminUser'
import PdfInfo from '@/components/PdfInfo'
import AdminSelectUser from '@/components/AdminSelectUser'
import UserList from '@/components/UserList'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// main.js
import htmlToPdf from '@/utils/htmlToPdf'
//把axios实例化后引入main.js文件。挂载在axios原型链上全局使用。
import http from "./utils/http";
Vue.prototype.$axios = http

import Router from 'vue-router'
Vue.config.productionTip = false
Vue.use(htmlToPdf)
Vue.use(Vant) // 使用 Vant
Vue.use(Router) // 使用 Vue Router
Vue.use(ElementUI)
const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/adminUser',
      name: 'AdminUser',
      component: AdminUser
    },
    {
      path: '/pdfInfo',
      name: 'PdfInfo',
      component: PdfInfo
    },
    {
      path: '/userList',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/adminSelectUser',
      name: 'AdminSelectUser',
      component: AdminSelectUser
    },
  ]
})
new Vue({
  render: h => h(App),
  router
}).$mount('#app')

export default router